export default "__VITE_ASSET__95c7549e__"